(function() {
  'use strict';

  angular
    .module('pub.channels.translation.service', [])
    .factory('TranslationChannelService', TranslationChannelService);

  /** @ngInject */
  function TranslationChannelService($http, $q, API) {
    function listTranslations(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'publisher/channels/' + id + '/channel_translations')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function getTranslation(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'publisher/channel_translations/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function createTranslation(id, model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'publisher/channels/' + id + '/channel_translations?automatic=true', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateTranslation(id, model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'publisher/channel_translations/' + id + '?automatic=true', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeTranslation(id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'publisher/channel_translations/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return{
      listTranslations: listTranslations,
      getTranslation: getTranslation,
      createTranslation: createTranslation,
      updateTranslation: updateTranslation,
      removeTranslation: removeTranslation
    };

  }

})();
